export default __webpack_public_path__ + "media/images/apple-icon-d1f91918.svg";